// extracted by mini-css-extract-plugin
export default {"button":"LoginButton_button__tRLDr","footnote":"LoginButton_footnote__Da47G"};